/**
* WARNING: This is an autogenerated file.  Do not edit by hand.
* To regenerate, run: pnpm i18n:extract-external-strings
*/

import {t, plural} from "@lingui/core/macro";
import type {PerseusStrings} from "@khanacademy/perseus/strings";
export const perseusStrings = (): PerseusStrings => ({
    "characterCount": ({num, used}) => plural(num, {
        one: `${used} / # Character`,
        other: `${used} / # Characters`,
    }),
    "closeKeypad": t`close math keypad`,
    "openKeypad": t`open math keypad`,
    "mathInputBox": t`Math input box`,
    "removeHighlight": t`Remove highlight`,
    "addHighlight": t`Add highlight`,
    "hintPos": ({pos}) => t`Hint #${pos}`,
    "errorRendering": ({error}) => t`Error rendering: ${error}`,
    "APPROXIMATED_PI_ERROR": t`Your answer is close, but you may have approximated pi. Enter your answer as a multiple of pi, like 12 pi or 2/3 pi`,
    "EXTRA_SYMBOLS_ERROR": t`We could not understand your answer. Please check your answer for extra text or symbols.`,
    "NEEDS_TO_BE_SIMPLFIED_ERROR": t`Your answer is almost correct, but it needs to be simplified.`,
    "MISSING_PERCENT_ERROR": t`Your answer is almost correct, but it is missing a <code>\\%</code> at the end.`,
    "MULTIPLICATION_SIGN_ERROR": t`I'm a computer. I only understand multiplication if you use an asterisk (*) as the multiplication sign.`,
    "USER_INPUT_EMPTY": t`Your answer is empty.`,
    "USER_INPUT_TOO_LONG": t`Please shorten your response.`,
    "WRONG_CASE_ERROR": t`Your answer includes use of a variable with the wrong case.`,
    "WRONG_LETTER_ERROR": t`Your answer includes a wrong variable letter.`,
    "invalidSelection": t`Make sure you select something for every row.`,
    "INVALID_CHOICE_SELECTION": t`Invalid choice selection`,
    "ERROR_TITLE": t`Oops!`,
    "ERROR_MESSAGE": t`Sorry, I don't understand that!`,
    "hints": t`Hints`,
    "getAnotherHint": t`Get another hint`,
    "deprecatedStandin": t`Sorry, this part of the question is no longer available. 😅 Don't worry, you won't be graded on this part. Keep going!`,
    "keepTrying": t`Keep trying`,
    "tryAgain": t`Try again`,
    "check": t`Check`,
    "correctExcited": t`Correct!`,
    "nextQuestion": t`Next question`,
    "skipToTitle": ({title}) => t`Skip to ${title}`,
    "current": t`Current`,
    "correct": t`Correct`,
    "correctSelected": t`Correct (selected)`,
    "incorrect": t`Incorrect`,
    "incorrectSelected": t`Incorrect (selected)`,
    "hideExplanation": t`Hide explanation`,
    "explain": t`Explain`,
    "INVALID_MESSAGE_PREFIX": t`We couldn't grade your answer.`,
    "DEFAULT_INVALID_MESSAGE_1": t`It looks like you left something blank or `,
    "DEFAULT_INVALID_MESSAGE_2": t`entered in an invalid answer.`,
    "integerExample": t`an integer, like $6$`,
    "properExample": t`a *proper* fraction, like $1/2$ or $6/10$`,
    "simplifiedProperExample": t`a *simplified proper* fraction, like $3/5$`,
    "improperExample": t`an *improper* fraction, like $10/7$ or $14/8$`,
    "simplifiedImproperExample": t`a *simplified improper* fraction, like $7/4$`,
    "mixedExample": t`a mixed number, like $1\\ 3/4$`,
    "decimalExample": t`an *exact* decimal, like $0.75$`,
    "percentExample": t`a percent, like $12.34\\%$`,
    "piExample": t`a multiple of pi, like $12$ pi or $2/3$ pi`,
    "yourAnswer": t`**Your answer should be** `,
    "yourAnswerLabel": t`Your answer:`,
    "addPoints": t`Click to add points`,
    "addVertices": t`Click to add vertices`,
    "tapMultiple": t`Tap each dot on the image to select all answers that apply.`,
    "tapSingle": t`Tap each dot on the image to select an answer.`,
    "clickMultiple": t`Click each dot on the image to select all answers that apply.`,
    "clickSingle": t`Click each dot on the image to select an answer.`,
    "choices": t`Choices:`,
    "answers": ({num}) => plural(num, {
        one: `# answer`,
        other: `# answers`,
    }),
    "hideAnswersToggleLabel": t`Hide answer choices`,
    "moves": ({num}) => plural(num, {
        one: `Moves: #`,
        other: `Moves: #`,
    }),
    "clickTiles": t`Click on the tiles to change the lights.`,
    "turnOffLights": t`You must turn on all of the lights to continue.`,
    "fillAllCells": t`Make sure you fill in all cells in the matrix.`,
    "molecularDrawing": ({content}) => t`A molecular structure drawing. SMILES notation: ${content}`,
    "switchDirection": t`Switch direction`,
    "circleOpen": t`Make circle open`,
    "circleFilled": t`Make circle filled`,
    "numDivisions": t`Number of divisions:`,
    "divisions": ({divRangeString}) => t`Please make sure the number of divisions is in the range ${divRangeString}.`,
    "lineRange": ({lineRange}) => t`lines ${lineRange}`,
    "lineNumber": ({lineNumber}) => t`line ${lineNumber}`,
    "symbolPassage": ({questionSymbol, questionNumber}) => t`The symbol ${questionSymbol} indicates that question ${questionNumber} references this portion of the passage.`,
    "symbolQuestion": ({sentenceSymbol}) => t` The symbol ${sentenceSymbol} indicates that the following sentence is referenced in a question.`,
    "lineLabel": t({
        context: "a label next to a reading passage to denote the line number",
        message: `Line`,
    }),
    "beginningPassage": t`Beginning of reading passage.`,
    "beginningFootnotes": t`Beginning of reading passage footnotes.`,
    "endPassage": t`End of reading passage.`,
    "questionMarker": ({number}) => t`[Marker for question ${number}]`,
    "circleMarker": ({number}) => t`[Circle marker ${number}]`,
    "sentenceMarker": ({number}) => t`[Sentence ${number}]`,
    "dragHandles": t`Drag handles to make graph`,
    "tapAddPoints": t`Tap to add points`,
    "false": t`False`,
    "true": t`True`,
    "no": t`No`,
    "yes": t`Yes`,
    "chooseCorrectNum": t`Please choose the correct number of answers.`,
    "notNoneOfTheAbove": t`'None of the above' may not be selected when other answers are selected.`,
    "noneOfTheAbove": t`None of the above`,
    "chooseNumAnswers": ({numCorrect}) => t`Choose ${numCorrect} answers:`,
    "chooseAllAnswers": t`Choose all answers that apply:`,
    "chooseOneAnswer": t`Choose 1 answer:`,
    "choiceCheckedCorrect": ({letter}) => t`(Choice ${letter}, Checked, Correct)`,
    "choiceCorrect": ({letter}) => t`(Choice ${letter}, Correct)`,
    "choiceCheckedIncorrect": ({letter}) => t`(Choice ${letter}, Checked, Incorrect)`,
    "choiceIncorrect": ({letter}) => t`(Choice ${letter}, Incorrect)`,
    "choiceChecked": ({letter}) => t`(Choice ${letter}, Checked)`,
    "choice": ({letter}) => t`(Choice ${letter})`,
    "notSelected": t({
        context: "Screen reader announcement for a choice that is not selected",
        message: `not selected`,
    }),
    "choicesSelected": ({num}) => plural(num, {
        one: `# choice selected`,
        other: `# choices selected`,
    }),
    "bringBack": t`Bring back`,
    "openMenuForChoice": ({letter}) => t`Open menu for Choice ${letter}`,
    "letters": t({
        context: "This is a list of single-character labels that will appear in front of multiple-choice options. For instance, a multiple-choice question with three options would display (A) first option (B) second option (C) third option. There must be spaces between each of the different characters. The characters will show up next to options in the order that they are listed here. Most multiple choice questions have 5 or fewer options.",
        message: `A B C D E F G H I J K L M N O P Q R S T U V W X Y Z`,
    }),
    "scrollAnswers": t`Scroll Answers`,
    "scrollStart": t`Scroll to view start of the content`,
    "scrollEnd": t`Scroll to view the end of the content`,
    "rightArrow": t`Reaction arrow pointing to the right.`,
    "dontUnderstandUnits": t`I couldn't understand those units.`,
    "checkSigFigs": t`Check your significant figures.`,
    "answerNumericallyIncorrect": t`That answer is numerically incorrect.`,
    "checkUnits": t`Check your units.`,
    "dontUnderstand": t`I don't understand that`,
    "loading": t`Loading...`,
    "videoTranscript": t`See video transcript`,
    "somethingWrong": t`Something went wrong.`,
    "videoWrapper": t`Khan Academy video wrapper`,
    "mathInputTitle": t`mathematics keyboard`,
    "mathInputDescription": t`Use keyboard/mouse to interact with math-based input fields`,
    "sin": t`sin`,
    "cos": t`cos`,
    "tan": t`tan`,
    "simulationLoadFail": t`Sorry, this simulation cannot load.`,
    "simulationLocaleWarning": t`Sorry, this simulation isn't available in your language.`,
    "selectAnAnswer": t`Select an answer`,
    "addPoint": t`Add Point`,
    "removePoint": t`Remove Point`,
    "graphKeyboardPrompt": t`Press Shift + Enter to interact with the graph`,
    "srInteractiveElements": ({elements}) => t`Interactive elements: ${elements}`,
    "srNoInteractiveElements": t`No interactive elements`,
    "closePolygon": t({
        context: "Button label for the button that closes an incomplete polygon created by the user in the interactive graph widget.",
        message: `Close shape`,
    }),
    "openPolygon": t({
        context: "Button label for the button that opens a closed polygon created by the user in the interactive graph widget.",
        message: `Re-open shape`,
    }),
    "srGraphInstructions": t({
        context: "Screen reader-only instructions for using the keyboard to move through the interactive elements in the interactive graph widget.",
        message: `Use the Tab key to move through the interactive elements in the graph. When an interactive element has focus, use Control + Shift + Arrows to move it.`,
    }),
    "srUnlimitedGraphInstructions": t({
        context: "Screen reader-only instructions for using the keyboard to move through the 'unlimited' (addable/deletable by the user) interactive elements in the interactive graph widget.",
        message: `Press Shift + Enter to interact with the graph. Use the Tab key to move through the interactive elements in the graph and access the graph Action Bar. When an interactive element has focus, use Control + Shift + Arrows to move it or use the Delete key to remove it from the graph. Use the buttons in the Action Bar to add or adjust elements within the graph.`,
    }),
    "srPointAtCoordinates": ({num, x, y}) => t({
        context: "Aria label for an interactive Point element in the interactive graph widget, including the count for its order in the points (e.g. 'Point 1 at 0 comma 0'). Coordinate (x, y) is written out as 'x comma y'.",
        message: `Point ${num} at ${x} comma ${y}.`,
    }),
    "srCircleGraph": t({
        context: "Aria label for the container containing the Circle and its interactive elements in the interactive graph widget.",
        message: `A circle on a coordinate plane.`,
    }),
    "srCircleShape": ({centerX, centerY}) => t({
        context: "Aria label for the interactive Circle element in the interactive graph widget.",
        message: `Circle. The center point is at ${centerX} comma ${centerY}.`,
    }),
    "srCircleRadiusPointRight": ({radiusPointX, radiusPointY}) => t({
        context: "Aria label for the interactive Point element that represents the radius endpoint when it's on the right side of the Circle in the interactive graph widget.",
        message: `Right radius endpoint at ${radiusPointX} comma ${radiusPointY}.`,
    }),
    "srCircleRadiusPointLeft": ({radiusPointX, radiusPointY}) => t({
        context: "Aria label for the interactive Point element that represents the radius endpoint when it's on the left side of the Circle in the interactive graph widget.",
        message: `Left radius endpoint at ${radiusPointX} comma ${radiusPointY}.`,
    }),
    "srCircleRadius": ({radius}) => t({
        context: "Screen reader description for the radius of the Circle in the interactive graph widget.",
        message: `Circle radius is ${radius}.`,
    }),
    "srCircleOuterPoints": ({point1X, point1Y, point2X, point2Y, point3X, point3Y, point4X, point4Y}) => t({
        context: "Screen reader description for four key points on the Circle in the interactive graph widget.",
        message: `Points on the circle at ${point1X} comma ${point1Y}, ${point2X} comma ${point2Y}, ${point3X} comma ${point3Y}, ${point4X} comma ${point4Y}.`,
    }),
    "srLinearGraph": t({
        context: "Aria label for the container containing the Line and its interactive elements in the interactive graph widget.",
        message: `A line on a coordinate plane.`,
    }),
    "srLinearGraphPoints": ({point1X, point1Y, point2X, point2Y}) => t({
        context: "Screen reader description for the two points defining the Line in the interactive graph widget.",
        message: `The line has two points, point 1 at ${point1X} comma ${point1Y} and point 2 at ${point2X} comma ${point2Y}.`,
    }),
    "srLinearGraphSlopeIncreasing": t({
        context: "Screen reader description for the upward slope of the Line in the interactive graph widget.",
        message: `Its slope increases from left to right.`,
    }),
    "srLinearGraphSlopeDecreasing": t({
        context: "Screen reader description for the downward slope of the Line in the interactive graph widget.",
        message: `Its slope decreases from left to right.`,
    }),
    "srLinearGraphSlopeHorizontal": t({
        context: "Screen reader description for the slope of a horizontal Line in the interactive graph widget.",
        message: `Its slope is zero.`,
    }),
    "srLinearGraphSlopeVertical": t({
        context: "Screen reader description for the slope of a vertical Line in the interactive graph widget.",
        message: `Its slope is undefined.`,
    }),
    "srLinearGraphXOnlyIntercept": ({xIntercept}) => t({
        context: "Screen reader description for the intercept of the Line in the interactive graph widget when it only intersects the X-axis.",
        message: `The line crosses the X-axis at ${xIntercept} comma 0.`,
    }),
    "srLinearGraphYOnlyIntercept": ({yIntercept}) => t({
        context: "Screen reader description for the intercept of the Line in the interactive graph widget when it only intersects the Y-axis.",
        message: `The line crosses the Y-axis at 0 comma ${yIntercept}.`,
    }),
    "srLinearGraphBothIntercepts": ({xIntercept, yIntercept}) => t({
        context: "Screen reader description for the intercepts of the Line in the interactive graph widget when it intersects both the X-axis and Y-axis.",
        message: `The line crosses the X-axis at ${xIntercept} comma 0 and the Y-axis at 0 comma ${yIntercept}.`,
    }),
    "srLinearGraphOriginIntercept": t({
        context: "Screen reader description for the intercept of the Line in the interactive graph widget when it intersects both the X-axis and Y-axis at the origin.",
        message: `The line crosses the X and Y axes at the graph's origin.`,
    }),
    "srLinearGrabHandle": ({point1X, point1Y, point2X, point2Y}) => t({
        context: "Aria label for the interactive segment that allows the user to move the whole Line in the interactive graph widget.",
        message: `Line going through point ${point1X} comma ${point1Y} and point ${point2X} comma ${point2Y}.`,
    }),
    "srAngleStartingSide": ({x, y}) => t({
        context: "Aria label for interactive Point 3 of the Angle in the interactive graph widget, explaining it's on the starting side of the Angle.",
        message: `Point 3, starting side at ${x} comma ${y}.`,
    }),
    "srAngleEndingSide": ({x, y}) => t({
        context: "Aria label for interactive Point 2 of the Angle in the interactive graph widget, explaining it's on the ending side of the Angle.",
        message: `Point 2, ending side at ${x} comma ${y}.`,
    }),
    "srAngleVertexWithAngleMeasure": ({x, y, angleMeasure}) => t({
        context: "Aria label for interactive Point 1 of the Angle in the interactive graph widget, explaining it's the vertex of the Angle.",
        message: `Point 1, vertex at ${x} comma ${y}. Angle ${angleMeasure} degrees.`,
    }),
    "srAngleGraphAriaLabel": t({
        context: "Aria label for the container containing the Angle and its interactive elements in the interactive graph widget.",
        message: `An angle on a coordinate plane.`,
    }),
    "srAngleGraphAriaDescription": ({angleMeasure, vertexX, vertexY, startingSideX, startingSideY, endingSideX, endingSideY}) => t({
        context: "Screen reader description for the measure of the Angle in the interactive graph widget.",
        message: `The angle measure is ${angleMeasure} degrees with a vertex at ${vertexX} comma ${vertexY}, a point on the starting side at ${startingSideX} comma ${startingSideY} and a point on the ending side at ${endingSideX} comma ${endingSideY}`,
    }),
    "srAngleInteractiveElements": ({vertexX, vertexY, startingSideX, startingSideY, endingSideX, endingSideY}) => t({
        context: "Screen reader description of all the elements available to interact with within the Angle graph in the interactive graph widget.",
        message: `An angle formed by 3 points. The vertex is at ${vertexX} comma ${vertexY}. The starting side point is at ${startingSideX} comma ${startingSideY}. The ending side point is at ${endingSideX} comma ${endingSideY}.`,
    }),
    "srSingleSegmentGraphAriaLabel": t({
        context: "Aria label for the container containing one Line Segment in the interactive graph widget.",
        message: `A line segment on a coordinate plane.`,
    }),
    "srMultipleSegmentGraphAriaLabel": ({countOfSegments}) => t({
        context: "Aria label for the container containing multiple Line Segments in the interactive graph widget.",
        message: `${countOfSegments} line segments on a coordinate plane.`,
    }),
    "srMultipleSegmentIndividualLabel": ({indexOfSegment, point1X, point1Y, point2X, point2Y}) => t({
        context: "Screen reader description for one individual Line Segment in the interactive graph widget, including the count for its order in the segments (e.g. 'Segment 1', 'Segment 2', etc.)",
        message: `Segment ${indexOfSegment}: Endpoint 1 at ${point1X} comma ${point1Y}. Endpoint 2 at ${point2X} comma ${point2Y}.`,
    }),
    "srSingleSegmentLabel": ({point1X, point1Y, point2X, point2Y}) => t({
        context: "Screen reader description for one individual Line Segment in the interactive graph widget.",
        message: `Endpoint 1 at ${point1X} comma ${point1Y}. Endpoint 2 at ${point2X} comma ${point2Y}.`,
    }),
    "srSegmentLength": ({length}) => t({
        context: "Screen reader description for the length of a Line Segment in the interactive graph widget.",
        message: `Segment length ${length} units.`,
    }),
    "srSingleSegmentGraphEndpointAriaLabel": ({endpointNumber, x, y}) => t({
        context: "Screen reader description for the endpoint of a Line Segment in the interactive graph widget when there is only one segment.",
        message: `Endpoint ${endpointNumber} at ${x} comma ${y}.`,
    }),
    "srMultipleSegmentGraphEndpointAriaLabel": ({endpointNumber, indexOfSegment, x, y}) => t({
        context: "Screen reader description for the endpoint of a Line Segment in the interactive graph widget when there are multiple segments. Includes the count for the segment's order (e.g. 'Segment 1', 'Segment 2', etc.)",
        message: `Endpoint ${endpointNumber} on segment ${indexOfSegment} at ${x} comma ${y}.`,
    }),
    "srSegmentGrabHandle": ({point1X, point1Y, point2X, point2Y}) => t({
        context: "Aria label for the interactive segment that allows the user to move the whole Line Segment in the interactive graph widget.",
        message: `Segment from ${point1X} comma ${point1Y} to ${point2X} comma ${point2Y}.`,
    }),
    "srLinearSystemGraph": t({
        context: "Aria label for the container containing two lines as part of a Linear System in the interactive graph widget.",
        message: `Two lines on a coordinate plane.`,
    }),
    "srLinearSystemPoints": ({lineNumber, point1X, point1Y, point2X, point2Y}) => t({
        context: "Screen reader description for the points of a line in the Linear System in the interactive graph widget.",
        message: `Line ${lineNumber} has two points, point 1 at ${point1X} comma ${point1Y} and point 2 at ${point2X} comma ${point2Y}.`,
    }),
    "srLinearSystemPoint": ({pointSequence, lineNumber, x, y}) => t({
        context: "Screen reader description for a point on a line in the Linear System in the interactive graph widget.",
        message: `Point ${pointSequence} on line ${lineNumber} at ${x} comma ${y}.`,
    }),
    "srLinearSystemGrabHandle": ({lineNumber, point1X, point1Y, point2X, point2Y}) => t({
        context: "Aria label for the interactive segment that allows the user to move a whole line in the Linear System in the interactive graph widget.",
        message: `Line ${lineNumber} going through point ${point1X} comma ${point1Y} and point ${point2X} comma ${point2Y}.`,
    }),
    "srLinearSystemIntersection": ({x, y}) => t({
        context: "Screen reader description for the intersection of two lines in the Linear System in the interactive graph widget.",
        message: `Line 1 and line 2 intersect at point ${x} comma ${y}.`,
    }),
    "srLinearSystemParallel": t({
        context: "Screen reader description when two lines are parallel in the Linear System in the interactive graph widget.",
        message: `Line 1 and line 2 are parallel.`,
    }),
    "srRayGraph": t({
        context: "Screen reader description for the container containing a Ray in the interactive graph widget.",
        message: `A ray on a coordinate plane.`,
    }),
    "srRayPoints": ({point1X, point1Y, point2X, point2Y}) => t({
        context: "Screen reader description for the points of a ray in the interactive graph widget.",
        message: `The endpoint is at ${point1X} comma ${point1Y} and the ray goes through point ${point2X} comma ${point2Y}.`,
    }),
    "srRayGrabHandle": ({point1X, point1Y, point2X, point2Y}) => t({
        context: "Aria label for the interactive segment that allows the user to move the whole Ray in the interactive graph widget.",
        message: `Ray with endpoint ${point1X} comma ${point1Y} going through point ${point2X} comma ${point2Y}.`,
    }),
    "srRayEndpoint": ({x, y}) => t({
        context: "Aria label for the initial point of a Ray (the point at which the ray starts) in the interactive graph widget.",
        message: `Endpoint at ${x} comma ${y}.`,
    }),
    "srRayTerminalPoint": ({x, y}) => t({
        context: "Aria label for the point that determines the direction of the Ray in the interactive graph widget. The ray passes through this point.",
        message: `Through point at ${x} comma ${y}.`,
    }),
    "srQuadraticGraph": t({
        context: "Aria label for the container containing a Quadratic function in the interactive graph widget.",
        message: `A parabola on a 4-quadrant coordinate plane.`,
    }),
    "srQuadraticFaceUp": t({
        context: "Screen reader description for the direction of the Quadratic function in the interactive graph widget when it opens upward.",
        message: `The parabola opens upward.`,
    }),
    "srQuadraticFaceDown": t({
        context: "Screen reader description for the direction of the Quadratic function in the interactive graph widget when it opens downward.",
        message: `The parabola opens downward.`,
    }),
    "srQuadraticGraphVertexOrigin": t({
        context: "Screen reader description for the Quadratic function in the interactive graph widget when its vertex is at the origin.",
        message: `Vertex is at the origin.`,
    }),
    "srQuadraticGraphVertexXAxis": t({
        context: "Screen reader description for the Quadratic function in the interactive graph widget when its vertex is on the X-axis.",
        message: `Vertex is on the X-axis.`,
    }),
    "srQuadraticGraphVertexYAxis": t({
        context: "Screen reader description for the Quadratic function in the interactive graph widget when its vertex is on the Y-axis.",
        message: `Vertex is on the Y-axis.`,
    }),
    "srQuadraticGraphVertexQuadrant": ({quadrant}) => t({
        context: "Screen reader description for the Quadratic function in the interactive graph widget when its vertex is in a specific quadrant (quadrant 1, 2, 3, or 4).",
        message: `Vertex is in quadrant ${quadrant}.`,
    }),
    "srQuadraticTwoXIntercepts": ({intercept1, intercept2}) => t({
        context: "Screen reader description for the X-intercepts of the Quadratic function in the interactive graph widget when there are two X-intercepts.",
        message: `The X-intercepts are at ${intercept1} comma 0 and ${intercept2} comma 0.`,
    }),
    "srQuadraticOneXIntercept": ({intercept}) => t({
        context: "Screen reader description for the X-intercept of the Quadratic function in the interactive graph widget when there is only one X-intercept.",
        message: `The X-intercept is at ${intercept} comma 0.`,
    }),
    "srQuadraticYIntercept": ({intercept}) => t({
        context: "Screen reader description for the Y-intercept of the Quadratic function in the interactive graph widget.",
        message: `The Y-intercept is at 0 comma ${intercept}.`,
    }),
    "srQuadraticPointOrigin": ({pointNumber}) => t({
        context: "Aria label for an interactive Point on the Quadratic function in the interactive graph widget when the Point is at the origin.",
        message: `Point ${pointNumber} on parabola at the origin.`,
    }),
    "srQuadraticPointAxis": ({pointNumber, x, y}) => t({
        context: "Aria label for an interactive Point on the Quadratic function in the interactive graph widget when the Point is on the X-axis or Y-axis.",
        message: `Point ${pointNumber} on parabola at ${x} comma ${y}.`,
    }),
    "srQuadraticPointQuadrant": ({pointNumber, quadrant, x, y}) => t({
        context: "Aria label for an interactive Point on the Quadratic function in the interactive graph widget when the Point is in a specific quadrant.",
        message: `Point ${pointNumber} on parabola in quadrant ${quadrant} at ${x} comma ${y}.`,
    }),
    "srQuadraticInteractiveElements": ({point1X, point1Y, point2X, point2Y, point3X, point3Y}) => t({
        context: "Screen reader description of all the elements available to interact with within the Quadratic function in the interactive graph widget.",
        message: `Parabola with points at ${point1X} comma ${point1Y}, ${point2X} comma ${point2Y}, and ${point3X} comma ${point3Y}.`,
    }),
    "srPolygonGraph": t({
        context: "Aria label for the container containing a Polygon in the interactive graph widget when it's on a plane/grid without axes.",
        message: `A polygon.`,
    }),
    "srPolygonGraphCoordinatePlane": t({
        context: "Aria label for the container containing a Polygon in the interactive graph widget when it's on a coordinate plane.",
        message: `A polygon on a coordinate plane.`,
    }),
    "srPolygonGraphPointsNum": ({num}) => t({
        context: "Screen reader description for the number of points in the Polygon in the interactive graph widget.",
        message: `The polygon has ${num} points.`,
    }),
    "srPolygonGraphPointsOne": t({
        context: "Screen reader description for the number of points in the Polygon in the interactive graph widget when there is only one point.",
        message: `The polygon has 1 point.`,
    }),
    "srPolygonElementsNum": ({num}) => t({
        context: "Screen reader description for the Polygon in the interactive graph widget explaining that it has a certain number of points.",
        message: `A polygon with ${num} points.`,
    }),
    "srPolygonElementsOne": t({
        context: "Screen reader description for the Polygon in the interactive graph widget explaining that it has one point.",
        message: `A polygon with 1 point.`,
    }),
    "srPolygonPointAngleApprox": ({angle}) => t({
        context: "Screen reader description for the angle of a point in the Polygon in the interactive graph widget when it's not an exact integer.",
        message: `Angle approximately equal to ${angle} degrees.`,
    }),
    "srPolygonPointAngle": ({angle}) => t({
        context: "Screen reader description for the angle of a point in the Polygon in the interactive graph widget when it's an integer.",
        message: `Angle equal to ${angle} degrees.`,
    }),
    "srPolygonSideLength": ({length, pointNum}) => t({
        context: "Screen reader description for the side of the Polygon in the interactive graph widget when its length is an exact integer.",
        message: `A line segment, length equal to ${length} units, connects to point ${pointNum}.`,
    }),
    "srPolygonSideLengthApprox": ({length, pointNum}) => t({
        context: "Screen reader description for the side of the Polygon in the interactive graph widget when its length is not an exact integer.",
        message: `A line segment, length approximately equal to ${length} units, connects to point ${pointNum}.`,
    }),
    "srUnlimitedPolygonEmpty": t({
        context: "Screen reader description for the empty container that will eventually contain a Polygon in the interactive graph widget after the user has added points.",
        message: `An empty coordinate plane.`,
    }),
    "srSinusoidGraph": t({
        context: "Aria label for the container containing a Sinusoid function in the interactive graph widget.",
        message: `A sinusoid function on a coordinate plane.`,
    }),
    "srSinusoidRootPoint": ({x, y}) => t({
        context: "Aria label for the Point defining the midline intersection of the Sinusoid function in the interactive graph widget.",
        message: `Midline intersection at ${x} comma ${y}.`,
    }),
    "srSinusoidMaxPoint": ({x, y}) => t({
        context: "Aria label for the Point defining the maximum of the Sinusoid function in the interactive graph widget.",
        message: `Maximum point at ${x} comma ${y}.`,
    }),
    "srSinusoidMinPoint": ({x, y}) => t({
        context: "Aria label for the Point defining the minimum of the Sinusoid function in the interactive graph widget.",
        message: `Minimum point at ${x} comma ${y}.`,
    }),
    "srSinusoidFlatPoint": ({x, y}) => t({
        context: "Aria label for the Point defining the amplitude of the Sinusoid function in the interactive graph widget when the amplitude is 0.",
        message: `Line through point at ${x} comma ${y}.`,
    }),
    "srSinusoidDescription": ({minValue, maxValue, cycleStart, cycleEnd}) => t({
        context: "Screen reader description of the Sinusoid function in the interactive graph widget.",
        message: `The graph shows a wave with a minimum value of ${minValue} and a maximum value of ${maxValue}. The wave completes a full cycle from ${cycleStart} to ${cycleEnd}.`,
    }),
    "srSinusoidInteractiveElements": ({point1X, point1Y, point2X, point2Y}) => t({
        context: "Screen reader description of all the elements available to interact with within the Sinusoid function in the interactive graph widget.",
        message: `Sinusoid graph with midline intersection point at ${point1X} comma ${point1Y} and extremum point at ${point2X} comma ${point2Y}.`,
    }),
    "imageExploreButton": t`Explore image`,
    "imageAlternativeTitle": t`Explore image and description`,
    "imageDescriptionLabel": t`Description`,
    "imageZoomAriaLabel": t`Zoom image.`,
    "imageResetZoomAriaLabel": t`Reset zoom.`,
});
